import styled from "styled-components";
import { Button, Card, Checkbox, Flex, Col, Divider } from "antd";

export const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  margin: 0px;
`;

export const CardTitle = styled(Card)`
  .ant-card-head-title {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const CheckboxItem = styled(Col)`
  width: calc(33.33% - 10px);
  display: flex;
  align-items: center;

  @media (max-width: 992px) {
    width: calc(50% - 10px);
  }
  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const CheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 checkboxes per row */
  gap: 10px; /* Add spacing between checkboxes */
  width: 100%;
`;

export const BtnWrapper = styled(Flex)`
  flex-wrap: wrap;
`;

export const checkbox = styled(Checkbox)`
  font-size: 14px;
  margin-left: 5px;
`;

export const GroupLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1d1d1d;
  margin-bottom: 12px;
  padding-bottom: 4px;
`;


export const PermissionGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  width: 100%;
`;

export const CheckboxSpan = styled.div<{ title: string }>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* width: calc(100%); */
`;

export const PermissionCheckbox = styled.div`
  flex: 0 0 calc(33.33% - 24px);
  max-width: calc(33.33% - 24px);
  min-width: calc(33.33% - 24px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  gap: 10px;
  cursor: pointer;

  @media (max-width: 1023px) {
    flex: 0 0 calc(50% - 24px);
    max-width: calc(50% - 24px);
  }

  @media (max-width: 767px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const RoleConfigWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

export const RoleConfigDivider = styled(Divider)`
  border: 0.5px solid #c6c6c6;
`;